<template lang="pug">
	.animated.fadeIn.preview-screen
		.preview-frame(:style="dimensions" v-show="Project.SelectedProject && Project.isSelectedProjectLoaded() && frameSrc")
			iframe(ref="iframe" :src="frameSrc" frameborder="0" :width="dimensions.width" :height="dimensions.height" allow='autoplay' allowfullscreen)
</template>

<script>

	import Screen 						from './../../mixins/screen';

	import { Publisher }				from '../../services/Publisher'
	import { Project }					from '../../services/Project'
	import { Version }					from '../../services/Version'
	import { Settings }					from '../../services/Settings'
	import { Asset }					from '../../services/Asset'
	import { Localization }				from '../../services/Localization'
	import { Layout } 					from './../../services/Layout'

	export default {
		name: 'preview',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Aside State Changed"],
			events: {
				"Selected Version Changed,Selected Project Fully Loaded": function() {

					if (Project.isSelectedProjectLoaded() && Version.SelectedVersion) this.refresh(10, true, true);

				},
				"Selected Project Changed,Aside State Changed,Sub Aside State Changed,Preview Device Changed,Preview Orientation Changed": function() {

					this.processFrameSize();

				},
				"Pull Project Done": function(pullProjectId) {

					if (pullProjectId === Project.SelectedProject.id) this.refresh(1000, true, true);

				},
				"Selected Version Setting Changed": function(settingCodename, value) {

					this.sendToIFrameSetting(settingCodename, value);

					if (settingCodename === "banner-width" || settingCodename === "banner-height") this.processFrameSize();
					if (settingCodename === "banner-width" || settingCodename === "banner-height") this.processFrameSize();

				},
				"Refresh Iframe": function() {

					this.refresh(10, true, false);

				},
				"Selected Banner Script Changed": function() {

					this.refresh(10, true, true);

				},
				"Selected End Card Script Changed": function() {

					this.refresh(1000, true);

				},
				"Selected Version Asset Changed,Selected Version Asset Restored,Selected Version Asset Deleted": function(versionId, assetCodename) {

					let message = {
						setAssets: {}
					};

					let asset = Asset.getAsset(Version.Versions[versionId], assetCodename);

					if (asset) message.setAssets[Asset.getMergedAssetCodename(asset)] = Asset.getMergedAsset(asset, Settings.getVersionSettingValue(asset['version_id'], 'separated-images-in-dashboard-preview'));
					else message.setAssets[assetCodename] = null;

					if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(message, '*');

					this.log(message);

				},
				"Selected Version Localization Changed": function(versionId, locale, localizationCodename) {

					let versionLocalization = Localization.getVersionLocalization(Version.Versions[versionId]);

					this.sendToIFrameLocalization(locale, localizationCodename, versionLocalization?.[locale]?.[localizationCodename]);

				},
				"Localization Message Changed": function(locale, codename, text_message) {

					this.sendToIFrameLocalizationMessage(locale, codename, text_message);

				},
				"Localization Style Changed": function(locale, codename, style_name, style_value) {

					this.sendToIFrameLocalizationStyle(locale, codename, style_name, style_value);

				},
				"Send To iFrame": function(data) {

					if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(data, '*');

					this.log(data);

				}
			}
		},
		components: {

		},
		data() {

			this.Publisher = Publisher;
			this.Project = Project;
			this.Settings = Settings;

			return {
				showed: true,
				frameSrc: Settings.getFrameSrc(true),
				devices: {
					iPad: {
						width: 768,
						height: 1024,
						ratio: 4/3,
						text: ['4', '3']
					},
					iPhone: {
						width: 375,
						height: 667,
						ratio: 16/9,
						text: ['16', '9']
					},
					iPhoneX: {
						width: 375,
						height: 812,
						ratio: 19.5/9,
						text: ['19.5', '9']
					},
					square: {
						width: 1024,
						height: 1024,
						ratio: 1,
						text: ['1', '1']
					}
				},
				windowWidth: 0,
				windowHeight: 0,
				dimensions: {}
			};

		},
		created() {

			window.addEventListener('resize', () => {

				this.windowWidth =  window.innerWidth;
				this.windowHeight = window.innerHeight;

				this.processFrameSize();

			});

			window.addEventListener("message", e => {

				if (e.data?.["BannerReady"]) this.sendToIFrameBannerInitData();

			});

			window.addEventListener("mousedown", e => {

				if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage({press: true}, '*');

			});

			this.windowWidth =  window.innerWidth;
			this.windowHeight = window.innerHeight;

			this.processFrameSize();

		},
		methods: {
			refresh(timeout, force, reset_device_and_orientation) {

				clearTimeout(this.refreshTimeout);
				this.refreshTimeout = setTimeout(() => {

					this.frameSrc = Settings.getFrameSrc(force);

					this.$forceUpdate();

					if (reset_device_and_orientation) {

						Layout.setPreviewDeviceFromSettings();
						Layout.setPreviewOrientationFromSettings();

					}

				}, timeout || 1000);

			},
			processFrameSize() {

				if (!Project.SelectedProject || !Version.SelectedVersion) return;
				if (!Layout.previewDevice || !Layout.previewOrientation[Layout.previewDevice]) return;

				let proportions_width = 0,
					proportions_height = 0,
					top = 0;

				if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

					const proportions = this.devices[Layout.previewDevice];

					proportions_width = proportions.width * 1.2;
					proportions_height = proportions.height * 1.2;

				} else if (Project.SelectedProject.type === 'banner') {

					let templateId = Project.SelectedProject.options.templateId;
					if (Version.SelectedVersion && Version.SelectedVersion.options.templateId) templateId = Version.SelectedVersion.options.templateId;
					let template = Metadata.Templates[templateId];

					proportions_width = template.options.width;
					proportions_height = template.options.height;

					if (Settings.SettingsByVersionByCodename[Version.SelectedVersion?.id]?.['banner-width']?.value) proportions_width = Settings.SettingsByVersionByCodename[Version.SelectedVersion.id]['banner-width'].value;
					if (Settings.SettingsByVersionByCodename[Version.SelectedVersion?.id]?.['banner-height']?.value) proportions_height = Settings.SettingsByVersionByCodename[Version.SelectedVersion.id]['banner-height'].value;

				}

				let frame_width = window.innerWidth,
					frame_height = window.innerHeight;

				//console.log('frame_width', frame_width);

				frame_height -= 54; //header
				frame_height -= 15; //devices

				frame_width -= Layout.getProjectsPlaneWidth() + Layout.projectsVersionsPlaneWidth;
				if (Layout.asideOpened) frame_width -= Layout.asideSize; //aside
				if (Layout.subAsideOpened) frame_width -= Layout.subAsideSize; //aside

				//console.log('frame_width', frame_width);

				if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

					if (Layout.previewOrientation[Layout.previewDevice] === 'landscape') {

						[proportions_width, proportions_height] = [proportions_height, proportions_width];

					}

				}

				//console.log('proportions', proportions_width, proportions_height);

				const screen_percent = 0.9;
				let scale = 1;

				if (proportions_height > frame_height * screen_percent) {

					let height_percent = frame_height * screen_percent / proportions_height;

					if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

						proportions_height = Math.floor(proportions_height * height_percent);
						proportions_width = Math.floor(proportions_width * height_percent);

					} else if (Project.SelectedProject.type === 'banner') {

						scale = Math.min(scale, height_percent);

					}

				}

				//console.log('proportions', proportions_width, proportions_height);

				if (proportions_width > frame_width * screen_percent) {

					let width_percent = frame_width * screen_percent / proportions_width;

					if (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') {

						proportions_height = Math.floor(proportions_height * width_percent);
						proportions_width = Math.floor(proportions_width * width_percent);

					} else if (Project.SelectedProject.type === 'banner') {

						scale = Math.min(scale, width_percent);

					}

				}

				//console.log('proportions', proportions_width, proportions_height);

				top = (frame_height - proportions_height) * 0.5;

				this.dimensions = {
					width: Math.floor(proportions_width) + 'px',
					height: Math.floor(proportions_height) + 'px',
					marginTop: top + 'px',
					transform: `scale(${scale})`
				};

				//this.$forceUpdate();

			},
			sendToIFrameBannerInitData() {

				let message = {
					init: {
						Assets: Asset.cleanVersionAssets(Asset.getVersionAssets(Version.SelectedVersion)),
						Settings: _.merge(Settings.getVersionSettings(Version.SelectedVersion), {"dashboard-preview-mode": true}),
						Localization: Localization.cleanVersionLocalization(Localization.getVersionLocalization(Version.SelectedVersion))
					}
				};

				if (this.$refs?.iframe?.contentWindow) this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

				this.processFrameSize();

			},
			sendToIFrameSetting(settingCodename, value) {

				let settingProps = Settings.getSettingProps(settingCodename);
				if (!settingProps) return;

				let message = null;

				if ((Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card') && settingProps.options["autoApplyChanges"]) {

					message = {
						setSettings: {}
					};

					message.setSettings[settingCodename] = value;

				} else if (Project.SelectedProject.type === 'banner') {

					message = {
						applySettings: {}
					};

					message.applySettings[settingCodename] = value;

				}

				if (this.$refs.iframe && message) {

					this.$refs.iframe.contentWindow.postMessage(message, '*');

					this.log(message);

				}

			},
			sendToIFrameLocalization(locale, codename, localization) {

				let message = {
					setLocalization: {
						[locale]: {
							[codename]: localization
						}
					}
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			sendToIFrameLocalizationMessage(locale, codename, text_message) {

				let message = {
					setLocalizationMessage: [locale, codename, text_message]
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			sendToIFrameLocalizationStyle(locale, codename, style_name, style_value) {

				let message = {
					setLocalizationStyle: [locale, codename, style_name, style_value]
				};

				this.$refs.iframe.contentWindow.postMessage(message, '*');

				this.log(message);

			},
			log() {

				console.info(`%c>>> SEND TO IFRAME >>`, 'color: #c06dd1', ...arguments);

			}
		}
	}
</script>

<style lang="sass">

	.preview-screen
		width: 100%
		height: 100%
		text-align: center

		.copy-settings
			position: absolute
			top: 0
			right: 0
			width: 150px

		.rotate-message
			color: #73818f
			font-size: 12px
			font-family: Arial, sans-serif
			margin-top: 10px
			cursor: default

		.preview-frame
			display: inline-block
			border: none
			box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.27), 0px 0px 7px rgba(0, 0, 0, 0.27)
			background-color: #cccccc
			transform-origin: left

	.preview-screen.mobile

		.device-control
			display: none

		.rotate-message
			display: none

		.preview-frame
			border: none
			position: fixed
			left: 0
			top: 0
			z-index: 10000

	.sub-aside-menu-show .preview-screen

			.controls
				width: calc(100% - 130px + 300px)

</style>

